export default __webpack_public_path__ + "static/icecream-health-1-mobile-efdb045624cd2dfc1e215835292d7b15.png";